import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {PorQue} from '@/components/ui/por-que'

/** Offers both reconciliations (onboarding-spec §3.1), never a silent pick. */
export function WorkerCountDivergenceNote({
  businessId,
  declared,
  active,
  editable,
  onUpdateDeclared,
  noticeTestId = 'worker-count-divergence-note',
  updateTestId = 'divergence-update-declared',
}: {
  businessId: string
  declared: number
  active: number
  editable: boolean
  onUpdateDeclared: () => void
  /** Overridable so the Empleados header keeps the testids of its approved E2E story. */
  noticeTestId?: string
  updateTestId?: string
}) {
  const {t} = useTranslation()
  if (declared === active) return null
  const activeIsLarger = active > declared

  return (
    <div
      className="notice-amber flex flex-wrap items-center justify-between gap-3 rounded-lg px-4 py-3"
      data-testid={noticeTestId}>
      <div className="min-w-0 space-y-1">
        <p className="text-sm">
          {t(activeIsLarger ? 'workerCount.divergence.bodyActiveLarger' : 'workerCount.divergence.bodyDeclaredLarger', {
            active,
            declared,
          })}
        </p>
        {/* T11: el rótulo se repite en dos pantallas; el nombre accesible lleva el dato. */}
        <PorQue
          label={t('workerCount.divergence.porque')}
          ariaLabel={t('workerCount.divergence.porqueAria')}
          testId={`${noticeTestId}-porque`}
          contenidoTestId={`${noticeTestId}-porque-detalle`}>
          {t('workerCount.divergence.porqueBody')}
        </PorQue>
      </div>
      <div className="flex shrink-0 flex-wrap gap-2">
        <Button asChild size="sm" variant="outline" data-testid="divergence-register-people">
          <Link to={`/businesses/${businessId}/employees`}>{t('workerCount.divergence.registerPeople')}</Link>
        </Button>
        {editable && (
          <Button size="sm" variant="outline" onClick={onUpdateDeclared} data-testid={updateTestId}>
            {t('workerCount.divergence.updateDeclared', {active})}
          </Button>
        )}
      </div>
    </div>
  )
}
